<div *ngIf="reservationInfo">
    <div [hidden]="ticketReservation.code || showTerms || confirm">
        <div class="row mb-2">
            <div class="col-lg-4 none-right-padding rightborder">
                <div class="column-header mb-3">{{ 'selected-bok' | translate }}</div>
                <div>{{ service.getSelectedLocation() }}</div>
                <div class="right-padding">
                    <app-reservation-questionaire [questions]="reservationInfo.questions"
                        (formInvalid)="checkForm($event)">
                    </app-reservation-questionaire>
                </div>
            </div>
            <div class="col-lg-4">
                <app-reservation-calendar [reservationsEndTime]="reservationInfo.configuration.reservationsEndTime"
                    [categoryMonthCapacity]="reservationInfo.categoryMonthCapacity">
                </app-reservation-calendar>
            </div>
            <div class="col-lg-4">
                <app-reservation-times [availableTimes]="reservationInfo.availableTimes"></app-reservation-times>
            </div>
        </div>
        
        <div class="row">
            <div class="col-lg-4">
                <div class="mb-2 small">Administratorem Twoich danych osobowych jest Enea S.A. z siedzibą w Poznaniu, ul. Pastelowa 8. Podanie przez Ciebie danych jest dobrowolne i będą one przetwarzane w celu umówienia wizyty w BOK.</div>
        
                <div class="mb-1">
                    <mat-checkbox color="primary" [(ngModel)]="termsChecked">
                        * {{ 'accept' | translate }}
                    </mat-checkbox>
                    <span class="terms mb-1" (click)="showTerms = !showTerms">{{ 'terms' | translate}} </span>
                    <span>{{ 'reservation-visit' | translate}}</span>
                </div>
                
                <div class="col-md-12 form-info" style="padding: 0px;"><span class="red">*</span> {{ 'necessary-info' | translate }}</div>
                
                <app-submit-reservation [formInvalid]="formInvalid" [reservationInfo]="reservationInfo"
                    [termsChecked]="termsChecked" (confirm)="confirmReservation($event)">
                </app-submit-reservation>
            </div>    
        </div>
    </div>
    <div [hidden]="!showTerms">
        <button (click)="showTerms = !showTerms" class="btn btn-primary">{{ 'back' | translate }}</button>
        <div [innerHTML]="reservationInfo.configuration.terms"></div>
        <button (click)="showTerms = !showTerms" class="btn btn-primary">{{ 'back' | translate }}</button>
    </div>
    <app-enea-confirmation-page *ngIf="!ticketReservation.code && confirm" [ticketReservation]="reservationToSend"
        [reservationInfo]="reservationInfo" (confirm)="undoConfirmReservation($event)">
    </app-enea-confirmation-page>   
    <app-reservation-confirm *ngIf="ticketReservation.code && confirm" [ticketReservation]="ticketReservation">
    </app-reservation-confirm>    
</div>
<div *ngIf="!reservationInfo">
    <mat-progress-spinner style="margin: auto;" color="primary" mode="indeterminate">
    </mat-progress-spinner>
</div>
